(function($) {

  window.isDragging = false;

  $.fn.vbSortable = function(options) {
    let onIndex = !document.getElementById("assignment_resource") ? "true" : "false"
    var defaults = {
      axis: 'y',
      scroll: 'true',
      cursorAt: { top: -5 },
      cancel: '.course-table__action-cell, .assignment-kebab-menu'
    };

    var setting = $.extend(defaults, options);
    setting["update"] = function() {
      // Prevent request firing if we don't have the proper data
      if (!$(this).sortable('serialize')) { return;}

      $.ajaxQueue({
      	type: "POST",
      	url: "/sortable_override/reorder",
      	data: $(this).sortable('serialize')
      });
    }

    setting["start"] = function (event, ui) {
      ui.helper.addClass('sortable-helper-dragging');
      window.isDragging = true;

      if (ui.item.hasClass("assignment-list-item")){
        ui.item.css("min-height","50px");
        if (onIndex === "true") {
          $('ul').find('.assignment-group:last').addClass('last-group-highlight');
        }
      }
    }

    setting["stop"] = function (event, ui) {
      window.isDragging = false;

      if (ui.item.hasClass("assignment-list-item")) {
        if (onIndex === "true") {
          $('ul').find('.assignment-group:last').removeClass('last-group-highlight');
          $('.group-highlight').removeClass('group-highlight')
        }
        ui.item.css("min-height", "0px");
      }
    }

    setting["over"] = function ( event, ui ) {
      if (ui.item.hasClass("assignment-list-item")) {
        if (onIndex === "true") {
          $('.group-highlight').removeClass('group-highlight')
          $(event.target).parent().parent().addClass('group-highlight')
        }
      }
    }

    setting["helper"] = function(e, tr) {
      if (tr.hasClass("course-table__row")) {
        const $originals = tr.children();
        const $helper = tr.clone();
        $helper.children().each(function(index) {
          $(this).width($originals.eq(index).outerWidth());
        });
        return $helper;
      }

      return tr.clone();
    };

    this.sortable(setting);
  };

})(jQuery);